/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadgeAlt4 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M9.106 10.94v1.2h3.35v1.36h1.48v-1.36h1v-1.3h-1V6.33h-1.39zm3.39-2.54v2.06l-.03.38h-1.75z" />
        <path d="M11.305.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 10l1.145 2.342a1 1 0 0 1-.43 1.323l-2.303 1.221-.45 2.568a1 1 0 0 1-1.125.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 17.906l-2.581.365a1 1 0 0 1-1.125-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 10 2.542 7.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 1.73l2.581.365zM12 2.391l-1.53 1.48a1 1 0 0 1-.835.272l-2.107-.299-.368 2.097a1 1 0 0 1-.516.71l-1.88.998.934 1.912a1 1 0 0 1 0 .878l-.934 1.912 1.88.998a1 1 0 0 1 .516.71l.368 2.097 2.107-.298a1 1 0 0 1 .835.27l1.53 1.48 1.53-1.48a1 1 0 0 1 .835-.27l2.107.298.368-2.097a1 1 0 0 1 .516-.71l1.88-.998-.934-1.912a1 1 0 0 1 0-.878l.934-1.912-1.88-.998a1 1 0 0 1-.516-.71l-.368-2.097-2.107.299a1 1 0 0 1-.835-.272z" />
        <path d="m9.087 18.965 1.522 1.473a2 2 0 0 0 2.782 0l1.522-1.473 1.087.154v4.88l-4-1.5L8 24v-4.88z" />
      </g>
    </g>
  </Icon>
);
export { SvgBadgeAlt4 as BadgeAlt4 };
